export const blacklistedVariantKeys = ['size_grouping'];
